import { formatTime } from "./formatting";

export const parseLocalDate = (dateStr) => {
  if (!dateStr) return null;
  if (dateStr.includes("T")) {
    return new Date(dateStr);
  }
  const [year, month, day] = dateStr.split("-");
  return new Date(year, month - 1, day);
};

/**
 * Any "zeus" in the location, to stay in step with the registration API, which
 * rejects SRI registrations for these sales, and with the website SQL's
 * IF(LCASE(LOCATION) LIKE '%zeus%', ...). Matching only the full
 * "www.zeusauction.com" left locations like "zeusauction.com" or "Zeus Auction"
 * showing an SRI Register button the API answers with a 400.
 */
export const isZeusHostedLocation = (locationStr) => /zeus/i.test(locationStr || "");

export const isOnlineOrZeus = (auction) => {
  const loc = auction?.location || "";
  const auctionType = auction?.type || "";

  // Check for underscores in location (Online Registration/In-Person Sale)
  if (loc.indexOf("___") !== -1) {
    return "Online Registration/In-Person Sale";
  }

  // Check for online type or Zeus location
  if (auctionType.toLowerCase() === "online" || isZeusHostedLocation(loc)) {
    return "Online/Zeus";
  }

  return false;
};

export const isHybridSale = (locationStr) => {
  if (!locationStr || typeof locationStr !== 'string') return false;
  return locationStr.indexOf("___") !== -1;
};

export const injectHardCodedRegistrationDates = (auctionDetail, saleId) => {
  const hardCodedDates = {
    registration_start_date: "2026-03-16T16:00:00.000Z",
    registration_end_date: "2026-04-10T16:00:00.000Z",
  };

  const qaMatch = process.env.REACT_APP_ENV === "qa" || (process.env.REACT_APP_ENV === "development" && Number(saleId) === 981);
  const prodMatch = process.env.REACT_APP_ENV === "production" && Number(saleId) === 1144;

  if (qaMatch || prodMatch) {
    return { ...auctionDetail, ...hardCodedDates };
  }

  return auctionDetail;
};

export const getRegistrationStatus = (auctionDetail) => {
  if (!auctionDetail?.registration_start_date || !auctionDetail?.registration_end_date) {
    return "open";
  }
  const now = new Date();
  const opens = parseLocalDate(auctionDetail.registration_start_date);
  const closes = parseLocalDate(auctionDetail.registration_end_date);
  if (now < opens) return "not_open";
  if (now > closes) return "closed";
  return "open";
};

export const returnPhysicalAddress = (locationStr) => {
  if (!locationStr) return null;
  const parts = locationStr.split(/\s*_{3,}\s*/);
  return parts.length > 1 ? parts[1].replace("Sale Location:", "").trim() : locationStr;
};

export const isRegistrationOpen = (auctionDetail) => {
  return getRegistrationStatus(auctionDetail) === "open";
};

export const registrationEndDateToDisplay = (auctionDetail) => {
  if (!auctionDetail?.registration_end_date) return "registration closing date";
  const date = parseLocalDate(auctionDetail.registration_end_date);
  return `${date.toLocaleDateString()} at ${formatTime(auctionDetail.registration_end_date)}`;
};